import axios from 'axios';
import { authConfig } from 'src/config';

const base64Token = btoa(
  `${authConfig.usernameAuth}:${authConfig.passwordAuth}`
);

if (base64Token) {
  axios.defaults.headers.common.Authorization = `Basic ${base64Token}`;
}

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    Promise.reject(
      (error.response && error.response.data) || 'Something went wrong'
    );
  }
);

export default axiosInstance;
